/**
  * goods商品模块接口列表
  */

//  import base from './base'; // 导入接口域名列表
import axios from './http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const goodstender = {
  // 招标范围接口   棚格图分类信息-棚格图（马仔文）
  getLayoutCategory (params) {
    return axios.post('/commoditymanagement/serviceApi/getSpaceClass',qs.stringify(params));
  },
  //招标状态
  getTenderStatus (params) {
    return axios.post('/scm-tendermanager/tender/getAllStatus',qs.stringify(params));
  },
  //投标任务列表
  getTenderBillList (params) {
    return axios.post('/scm-tendermanager/tender/getTenderBillHeaderByPrimarySupp',params);
  },
  //批量参与投标   参与投标
  participateTenderBatch (params) {
    return axios.post('/scm-tendermanager/tender/participateTenderBatch',params);
  },
  //投标详情查看
  showTenderDetail (params) {
    return axios.post('/scm-tendermanager/tender/showTenderDetail',params);
  },
  //招标商品列表
  tenderMasterList (params) {
    return axios.post('/scm-tendermanager/tender/tenderMasterList',params);
  },
  // 点击下载商品清单
  exportTenderMasterList (params){
    return axios({
      method: 'post',
      url: '/scm-tendermanager/tender/exportTenderMasterList',
      data: qs.stringify(params),
      responseType: 'blob'
    })
  },
  //进入报价列表
  selectTenderDetailByPrimarySupp (params) {
    return axios.post('/scm-tendermanager/tender/selectTenderDetailByPrimarySupp',params);
  },
  //招标报价
  investTender (params) {
    return axios.post('/scm-tendermanager/Invest/tender',qs.stringify(params));
  },
}

export default goodstender;


// WEBPACK FOOTER //
// ./src/api/api_goodstender.js